import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=19667163&scoped=true&lang=pug&"
import script from "./VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=19667163&prod&lang=sass&"
import style1 from "./VerifyEmail.vue?vue&type=style&index=1&id=19667163&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19667163",
  null
  
)

/* custom blocks */
import block0 from "./VerifyEmail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports